import React from 'react';
import { I18n, Trans } from 'react-i18next';


export class AppProfile extends React.Component {
  render() {
     
    return (
     <I18n ns="translations">
        {
          (t, { i18n }) => (
            <section id="slider-section">
                <div className="container-fluid">
                <h1 className="slider-heading-text ">
                 {t('clienttitle')}
                </h1>
                  <div id="myCarousel" className="carousel slide" data-ride="carousel">
                    <ol className="carousel-indicators">
                      <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
                      <li data-target="#myCarousel" data-slide-to="1"></li>
                      <li data-target="#myCarousel" data-slide-to="2"></li>
                      <li data-target="#myCarousel" data-slide-to="3"></li>
                      <li data-target="#myCarousel" data-slide-to="4"></li>
                      <li data-target="#myCarousel" data-slide-to="5"></li>
                      <li data-target="#myCarousel" data-slide-to="6"></li>
                      <li data-target="#myCarousel" data-slide-to="7"></li>
                      <li data-target="#myCarousel" data-slide-to="8"></li>
                      <li data-target="#myCarousel" data-slide-to="9"></li>
                      <li data-target="#myCarousel" data-slide-to="10"></li>
                      <li data-target="#myCarousel" data-slide-to="11"></li>
                      <li data-target="#myCarousel" data-slide-to="12"></li>
                      <li data-target="#myCarousel" data-slide-to="13"></li>
                    </ol>

                    <div className="carousel-inner">
                      <div className="item active">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                              <div className="slider-img-group">
                                  <img className="slider-img" src="images/slider_img.png"/>
                                   <img className="quote-img" src="images/quote-symbol.png"/>
                              </div>                
                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Très bonne app pour les amateurs. Étant amateur de vin j’ai été charmé par le design de l’application.
Claire, simple et jolie. Elle me convient parfaitement et la possibilité de choisir des crus en fonction de mes goûts est je trouve super pratique !</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/uncolored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">AMamat2769</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>

                      <div className="item">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_1_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Top ! Depuis le temps que je cherche une appli correcte dans le monde du vin... Je m'agace tous les jours de voir que je n'ai pas suffisamment de connaissance dans ce domaine si pratique au quotidien. Depuis que j'ai cette appli j'ai découvert beaucoup de chose sur cet art que je ne connais que trop peu. Elle m'aide à chaque repas. Merci! Continuez !</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Athalanth</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>

                      <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_2_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Incontournable ! Enfin une app qui innove dans le monde du vin ! En plus de tout ce qu'on attend traditionnellement (scan d'etiquettes, recommandations par goûts et par thèmes), Hapiwine nous fait bénéficier des conseils experts du vice meilleur sommelier du monde !</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Antoine Pichaud</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>

                      <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_3_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Indispensable pour les amateurs. Quand on est amateur de vin, mais pas oenologue, on ne sait pas trop comment décrire ce qu'on aime dans un vin et pourquoi. Haiwine aide à identifier des vins qui ressemblent à ceux qu'on aime, ce qui permet d'en découvrir de nouveaux avec peu de risques d'être déçus. Génial !!!</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Zeyug</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>

                      <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_4_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Bien fait. Application bien conçue, donne une idée de comment choisir et trouver le vin.</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Zhouyou</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>



                      <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_5_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">J'adore. Amateur de vins, nous cherchions l'application parfaite... enfin la voilà, simple, intuitive et moderne ... bravo</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Franceoiyt</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>


                       <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_6_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">L'appli est simple efficace et propose de bien belles bouteilles à des prix très raisonnables ! Je recommande vivement.</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Fxavier 1001</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>



                       <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_7_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Super appli, d'une grande aide. Conseillé à tous !</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">KawLnd</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>



                      <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_8_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">J'adore le vin mais je n'y connais rien ! Cette très belle application m'apporte enfin le plaisir de la connaissance et le bonheur de la découverte. Continuez comme ça HapiWine !</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Isa2875</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>


                      <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_9_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Le monde du vin se libère enfin du carcan élitiste et snob grâce à Hapiwine ! J'adopte 👌👏</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Ruesdescedres1990</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>


                      <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_10_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Très bonne application, beaucoup d'idées nouvelles. A découvrir absolument. Aide à la connaissance du vin ludique, conseils d'achats et de consommatoin, choix de vins en dehors des sentiers battus.</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Bonninda</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>



                       <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_11_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Une appli bien conçue et fort pratique</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Tristan Latgé</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>



                       <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_12_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Very useful to get to learn about wine and well tailored to one's tastes</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text"></h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>


                      <div className="item">
                       <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="row">
                            <div className="col-md-5 col-sm-5 col-xs-12 tr res-tc">
                             <div className="slider-img-group">
                                <img className="slider-img" src="images/slider_img_14_alt.png"/>
                                 <img className="quote-img" src="images/quote-symbol.png"/>
                             </div>                

                            </div>
                            <div className="col-md-7 col-sm-7 col-xs-12 tl res-tc">
                               <div className="slider-content">
                                  <h3 className="slider-text">Très utile, il fallait y penser</h3>
                                  <ul className="star-label">
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                    <li><img src="images/colored-star.png"/></li>
                                  </ul>
                                  <h5 className="slider-btm-text">Sandrine Doppler</h5>
                                </div>
                              </div>
                            </div>
                         </div>
                      </div>



                    </div>


                    







                    <a id="carousel-left" className="left carousel-control" href="#myCarousel" data-slide="prev">
                      <span className="slider-arrow"><img src="images/slider_left_arrow.png"/></span>
                      <span className="sr-only">Previous</span>
                    </a>
                    <a id="carousel-right" className="right carousel-control" href="#myCarousel" data-slide="next">
                      <span className="slider-arrow"><img src="images/slider_right_arrow.png"/></span>
                      <span className="sr-only">Next</span>
                    </a>
                  </div>
                </div>
              </section>
            )
          }
      </I18n> 
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/AppProfile/AppProfile.js